import { SpinnerType } from '@fcom/common-booking/interfaces/component-types.interface';
import { ElementTypes } from '@fcom/common/interfaces/gtm.interface';
import { FinnairBoundNote } from '@fcom/dapi/api/models/finnair-bound-note';
import { FinnairItineraryNote } from '@fcom/dapi/api/models/finnair-itinerary-note';
import { FinnairPassengerCode } from '@fcom/dapi/api/models/finnair-passenger-code';
import { BoundType } from '@fcom/dapi';

export class AppConstants {
  public static readonly FinnairPassengerCode = FinnairPassengerCode;
  public static readonly BoundType = BoundType;
  public static readonly SpinnerType = SpinnerType;
  public static readonly ElementTypes = ElementTypes;
  public static readonly FinnairBoundNote = FinnairBoundNote;
  public static readonly FinnairItineraryNote = FinnairItineraryNote;
}
